import { urlBase } from "./config";
import axiosInstance from "../services/config/axiosinstance";

async function getMobileAppsBuildConfigByBundle(bundle) {
  const config = {
    method: "get",
    url: `${urlBase}/mobileapp-build-config/bundle/${bundle}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function createAppBuildConfig(data) {
  const config = {
    method: "post",
    url: `${urlBase}/mobileapp-build-config`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function deleteAppBuildConfig(id) {
  const config = {
    method: "delete",
    url: `${urlBase}/mobileapp-build-config/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function updateAppBuildConfig(id, data) {
  const config = {
    method: "put",
    url: `${urlBase}/mobileapp-build-config/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

export {
  createAppBuildConfig,
  deleteAppBuildConfig,
  getMobileAppsBuildConfigByBundle,
  updateAppBuildConfig,
};
